"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isCancellationToken = exports.CancellationTokenState = void 0;
// token的状态
// eslint-disable-next-line @typescript-eslint/no-extraneous-class
var CancellationTokenState = /** @class */ (function () {
    function CancellationTokenState() {
    }
    CancellationTokenState.None = Object.freeze({
        isCancellationRequested: false,
    });
    CancellationTokenState.Cancelled = Object.freeze({
        isCancellationRequested: true,
    });
    return CancellationTokenState;
}());
exports.CancellationTokenState = CancellationTokenState;
// 判断是否是一个token
function isCancellationToken(thing) {
    if (thing === CancellationTokenState.None || thing === CancellationTokenState.Cancelled) {
        return true;
    }
    if (!thing || typeof thing !== 'object') {
        return false;
    }
    return (typeof thing.isCancellationRequested === 'boolean');
}
exports.isCancellationToken = isCancellationToken;
//# sourceMappingURL=cancellation-util.js.map